import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiQuestion';

import { all, put, takeEvery } from 'redux-saga/effects';
import {
  OFFLINE_USER,
  RESET_FAIL,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
} from '../../shared/constants/Constants';

import {
  listOFQuestions,
  Logout,
  showListOfMainTopics,
  showListOfSubTopics,
  startLoading,
  stopLoading,
} from '../actions';

import { checkOffline } from '../../shared/services/Utility';

function* getMainTopics(action) {
  try {
    yield put(startLoading());
    const data = yield api.getMainTopics(action.userId);

    if (data.status === 1) {
      yield put(stopLoading());
      yield put(showListOfMainTopics(data.topicsData));
    } else if (data.status === SESSION_EXPIRED_CODE) {
      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');

      yield put(Logout());
      // yield put(goto_login())
    } else {
      yield put(stopLoading());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

function* getListOfSubTopics(action) {
  try {
    yield put(startLoading());

    const data = yield api.getSubTopics(action.subTopicRequestBody);

    if (data.status === 1) {
      yield put(stopLoading());
      yield put(showListOfSubTopics(data.subTopicsData));
      const { cateName, question_count } = data.subTopicsData[0];
      action.success(question_count, cateName);
    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/

      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }

    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

function* getQuestionByID(action) {
  try {
    yield put(startLoading());
    const data = yield api.fetchQuestionByTopicId(action.questionBody);

    if (data.status === 1) {
      yield put(listOFQuestions(data.QuestionData));
      // yield put(goto_questions(action.questionId));
      yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/

      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      yield put(stopLoading());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

const delay = (ms) =>
  new Promise((res) => {
    setTimeout(res, ms);
  });

function* resetHiddenQuestions(action) {
  try {
    yield put(startLoading());
    const data = yield api.resetHiddenQuestions_API(
      action.resetHiddenQuestionsBody,
    );

    if (data.status === 1) {
      yield put(stopLoading());
      yield delay(150);
      action.success();

      // alert('reset successful')
    } else if (data.status === SESSION_EXPIRED_CODE || data.status === 0) {
      /*session id expired*/

      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      yield put(stopLoading());
      yield delay(150);
      action.errorSnackbar(RESET_FAIL, 'error');
    }
  } catch (e) {
    yield put(stopLoading());
    yield delay(150);
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

function* submitTestResponse(action) {
  // yield put(startLoading());

  try {
    const data = yield api.submitTestResponse(action.testResponseData);

    // yield put(stopLoading());
    if (data.status === 1) {
      yield put(stopLoading());
      if (action.back === false) {
        // yield put(backTo_Topics());
        setTimeout(() => {
          action.callback(data.message, '');
        }, 300);
      }
    } else if (action.back === true) {
      action.callback('', '');
      yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE || data.status === 0) {
      /*session id expired*/
      // if (!Utility.isAlertShowing) {
      //   Utility.updateAlertShowing(true);
      //   Alert.alert(APP_NAME, SESSION_EXPIRED, [
      //     {
      //       text: "OK",
      //       onPress: () => {
      //         Utility.updateAlertShowing(false);
      //       },
      //     },
      //   ]);
      //   // yield put(goto_login())
      // }
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
    // yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* hideQuestionResponse(action) {
  // yield put(startLoading());
  // alert("question--->", JSON.stringify(testResponseData.testResponseData));
  try {
    const data = yield api.submitTestResponse(action.testResponseData);
    // alert("result", JSON.stringify(data));
    // yield put(stopLoading());
    if (data.status === 1) {
      action.callback('', '');
      yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE || data.status === 0) {
      /*session id expired*/
      // if (!Utility.isAlertShowing) {
      //   Utility.updateAlertShowing(true);
      //   Alert.alert(APP_NAME, SESSION_EXPIRED, [
      //     {
      //       text: "OK",
      //       onPress: () => {
      //         Utility.updateAlertShowing(false);
      //       },
      //     },
      //   ]);
      //
      //   // yield put(goto_login())
      // }
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
    // yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* QuestionSaga() {
  yield all([
    takeEvery(actionTypes.GET_MAIN_TOPICS, getMainTopics),
    takeEvery(actionTypes.GET_SUB_TOPICS, getListOfSubTopics),
    takeEvery(actionTypes.QUESTION_BY_ID, getQuestionByID),
    takeEvery(actionTypes.RESET_HIDDEN_QUESTIONS, resetHiddenQuestions),
    // takeEvery(actionTypes.QUESTION_BY_ID, getQuestionByID),
    takeEvery(actionTypes.SUBMIT_QUESTION_TEST_RESPONSE, submitTestResponse),
    takeEvery(actionTypes.HIDDEN_QUESTIONS, hideQuestionResponse),
    //takeEvery(actionTypes.SUBMIT_QUESTION_TEST_RESPONSE,submitTestResponseOnBack)
  ]);
}

export default QuestionSaga;
